import { useTranslation } from "react-i18next"

export function NotFoundPage() {
  const { t } = useTranslation()
  return (
    <main className="flex min-h-screen items-center justify-center p-6">
      <div className="text-center">
        <p className="text-sm font-semibold text-(--color-primary)">
          404
        </p>

        <h1 className="mt-2 text-3xl font-bold">
          {t("titles.pageNotFound")}
        </h1>

        <p className="mt-2 text-(--color-muted-foreground)">
          {t("messages.pageNotFoundDescription")}
        </p>
      </div>
    </main>
  )
}